<template>
  <div class="assets-wrap page-padding">
    <ioc-table
      ref="crud"
      v-model="assets"
      :data="tableData"
      :option="option"
      :page="page"
      @row-save="handleCreate"
      @row-update="handleUpdate"
      @row-cancle="closeDialog"
      @search-change="handleSearchChange"
      @search-reset="handleSearchReset"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      @selection-change="handleSelectionChange"
    >
      <!-- 搜索框 自定义 -->
      <template slot="search_buildingName" slot-scope="scope">
        <el-select
          v-model="scope.row.buildingCode"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in buildingList"
            :key="item.buildingCode"
            :label="item.buildingName"
            :value="item.buildingCode"
          >
          </el-option>
        </el-select>
      </template>
      <!-- 顶部按钮 自定义 -->
      <template slot="menuLeft">
        <el-button
          type="primary"
          v-auth="'/assetsManage/assetsManage:add'"
          size="small"
          class="iss-operation-button"
          icon="el-icon-plus"
          @click="handleAddAssets"
        >
          {{ $t("workGroup.button.add") }}
        </el-button>
        <el-upload
          ref="upload"
          style="display: inline-block; margin: 0 10px"
          multiple
          :limit="1"
          :auto-upload="false"
          :on-change="batchImport"
          action
          :show-file-list="false"
        >
          <el-button
            type="primary"
            v-auth="'/assetsManage/assetsManage:import'"
            class="iss-operation-button-upload"
            icon="iconfont icon-daoru"
            >导入
          </el-button>
        </el-upload>
        <el-button
          type="primary"
          size="small"
          v-auth="'/assetsManage/assetsManage:delete'"
          icon="el-icon-delete"
          @click="handelDelAssets"
        >
          {{ $t("workGroup.button.batchDel") }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-auth="'/assetsManage/assetsManage:export'"
          icon="el-icon-download"
          @click="exportDocument"
        >
          导出
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-auth="'/assetsManage/assetsManage:export'"
          icon="el-icon-download"
          @click="exportPic"
          :disabled="exportDisabled"
        >
          {{ exportDisabled ? "正在导出" : "导出二维码" }}
        </el-button>
      </template>
      <!-- 表格按钮 自定义 -->
      <template slot="menu" slot-scope="scope">
        <el-tooltip
          class="item"
          effect="dark"
          content="修改"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            v-auth="'/assetsManage/assetsManage:update'"
            icon="iconfont icon-xiugai"
            @click="handleEdit(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="详情"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            icon="iconfont icon-Detail"
            @click="handleView(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
        <el-tooltip
          class="item"
          effect="dark"
          content="删除"
          placement="top"
          popper-class="tooltip-draw"
        >
          <el-button
            type="text"
            v-auth="'/assetsManage/assetsManage:delete'"
            icon="el-icon-delete"
            @click="handleDel(scope.row, scope.index)"
          ></el-button>
        </el-tooltip>
      </template>
      <!-- 表格列 自定义 -->
      <template slot="deviceQrCode" slot-scope="scope">
        <div @click="showCode(scope.row)">
          <!-- :logoSrc="downloadData.icon" -->
          <vue-qr
            :logoSrc="downloadData.icon"
            :text="h5Url + '?id=' + scope.row.fireassetCode"
            style="cursor: pointer"
            :size="50"
            :margin="5"
          ></vue-qr>
        </div>
      </template>
      <!-- 巡检点名称点击跳转详情 -->
      <template slot="fireassetName" slot-scope="scope">
        <span style="cursor: pointer" @click="handleView(scope.row, scope.index)">{{
          scope.row.fireassetName
        }}</span>
      </template>
      <!-- 新增/修改表单 自定义 -->
      <template slot="fireassetTypeForm" slot-scope="scope">
        <el-select
          type="select"
          @change="typeSelect(scope.row)"
          v-model="scope.row.fireassetType"
        >
          <el-option
            v-for="item in fireassetType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </template>
      <template slot="fireassetDetailForm" slot-scope="scope">
        <div class="slot-form" v-if="typeValue == 1 || typeValue == 2">
          <label class="item-label">灭火器：</label>
          <i class="el-icon-plus" @click="addFireasset(scope.row, 1)"></i>
          <div v-if="fireDisplay">
            <el-form
              :rules="annihilatorModel.annihilatorRule"
              :model="annihilatorModel"
              ref="annihilatorForm"
            >
              <el-table
                :data="annihilatorModel.annihilatorList"
                style="width: 100%"
                size="mini"
              >
                <el-table-column label="序号" width="50">
                  <template slot-scope="scopeItem">
                    <el-form-item
                      :prop="'annihilatorList.' + scopeItem.$index + '.order'"
                    >
                      <el-input
                        :value="scopeItem.$index + 1"
                        style="width: 45px; margin-left: -10px"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="名称" width="150">
                  <template slot-scope="scopeItem">
                    <el-form-item :prop="'annihilatorList.' + scopeItem.$index + '.name'">
                      <el-input
                        v-model="scopeItem.row.name"
                        placeholder="请输入名称"
                        style="width: 145px; margin-left: -10px"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="型号" width="100">
                  <template slot-scope="scopeItem">
                    <el-form-item
                      :prop="'annihilatorList.' + scopeItem.$index + '.fireassetVersion'"
                    >
                      <el-select
                        placeholder="请选择型号"
                        style="width: 105px; margin-left: -10px"
                        v-model="scopeItem.row.fireassetVersion"
                      >
                        <el-option
                          v-for="el in fireassetVersion"
                          :key="el.value"
                          :label="el.label"
                          :value="Number(el.value)"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="数量" width="80">
                  <template slot-scope="scopeItem">
                    <el-form-item
                      :prop="'annihilatorList.' + scopeItem.$index + '.number'"
                      :rules="annihilatorModel.annihilatorRule.number"
                    >
                      <el-input
                        placeholder="请输入数量 "
                        style="width: 95px; margin-left: -10px"
                        v-model.number="scopeItem.row.number"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="生产日期" width="150">
                  <template slot-scope="scopeItem">
                    <el-form-item
                      :prop="'annihilatorList.' + scopeItem.$index + '.produceTime'"
                    >
                      <el-date-picker
                        v-model="scopeItem.row.produceTime"
                        value-format="yyyy-MM-dd"
                        style="width: 50px; margin-left: -10px"
                        type="date"
                        placeholder="选择生产日期"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="检修日期" width="150">
                  <template slot-scope="scopeItem">
                    <el-form-item
                      :prop="'annihilatorList.' + scopeItem.$index + '.fixTime'"
                    >
                      <el-date-picker
                        v-model="scopeItem.row.fixTime"
                        value-format="yyyy-MM-dd"
                        style="width: 50px; margin-left: -10px"
                        type="date"
                        placeholder="选择检修日期"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="70">
                  <template slot-scope="scopeItem">
                    <i
                      class="el-icon-delete"
                      style="width: 30px; margin-left: 5px"
                      @click="removeFireasset(scopeItem.$index, 1)"
                    ></i>
                    <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">删除</el-button>
        <el-button type="text" size="small">编辑</el-button> -->
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </div>
        </div>
        <div class="slot-form" v-if="typeValue == 2">
          <label class="item-label">消火栓：</label>
          <i class="el-icon-plus" @click="addFireasset(scope.row, 2)"></i>
          <div v-if="fireplugDisplay">
            <el-form
              :rules="hydrantModel.hydrantRule"
              :model="hydrantModel"
              ref="hydrantForm"
            >
              <el-table :data="hydrantModel.hydrantList" style="width: 100%">
                <el-table-column label="序号" width="50">
                  <template slot-scope="scopeItem">
                    <el-form-item>
                      <el-input
                        :value="scopeItem.$index + 1"
                        style="width: 45px; margin-left: -10px"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="名称">
                  <template slot-scope="scopeItem">
                    <el-form-item :prop="'hydrantList.' + scopeItem.$index + '.name'">
                      <el-input
                        placeholder="请输入名称"
                        style="width: 145px; margin-left: -10px"
                        v-model.number="scopeItem.row.name"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="数量">
                  <template slot-scope="scopeItem">
                    <el-form-item
                      :prop="'hydrantList.' + scopeItem.$index + '.number'"
                      :rules="hydrantModel.hydrantRule.number"
                    >
                      <el-input
                        placeholder="请输入数量 "
                        style="width: 100%; margin-left: -10px"
                        v-model.number="scopeItem.row.number"
                      ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="70">
                  <template slot-scope="scopeItem">
                    <i
                      class="el-icon-delete"
                      style="width: 100%; margin-left: -10px"
                      @click="removeFireasset(scopeItem.row, 2)"
                    ></i>
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </div>
        </div>
        <!-- <el-input v-model="scope.row.personnelNames"
                  @focus="openChoose(scope.row)"
                  placeholder="请选择人员"
                  class="person-choose"></el-input> -->
      </template>
      <template slot="personnelNamesForm" slot-scope="scope">
        <el-input
          v-model="scope.row.personnelNames"
          @focus="openChoose(scope.row)"
          placeholder="请选择人员"
          class="person-choose"
        ></el-input>
      </template>
      <!-- <template slot="personnelPartForm">
        <el-input :value="assets.departmentName"
                 
                  class="person-choose"></el-input>
      </template> -->
      <template slot="buildingNameForm" slot-scope="scope">
        <el-select
          v-model="scope.row.buildingCode"
          placeholder="请选择"
          clearable
          filterable
          @change="handleBuildingChange(scope.row.buildingCode, scope.row)"
        >
          <el-option
            v-for="item in buildingList"
            :key="item.buildingCode"
            :label="item.buildingName"
            :value="item.buildingCode"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="floorNameForm" slot-scope="scope">
        <el-select
          v-model="scope.row.floorCode"
          @change="handleFloorChange(scope.row.floorCode, scope.row)"
          clearable
          filterable
          placeholder="请选择"
        >
          <el-option
            v-for="item in floorList"
            :key="item.buildingCode"
            :label="item.buildingName"
            :value="item.buildingCode"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="planCodeForm" slot-scope="scope">
        <el-select v-model="scope.row.planCode" clearable placeholder="请选择">
          <el-option
            v-for="item in planList"
            :key="item.planCode"
            :label="item.planName"
            :value="item.planCode"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="patrolItemGroupCodeForm" slot-scope="scope">
        <el-select v-model="scope.row.patrolItemGroupCode" clearable placeholder="请选择">
          <el-option
            v-for="item in groupList"
            :key="item.patrolItemGroupCode"
            :label="item.patrolItemGroupName"
            :value="item.patrolItemGroupCode"
          >
          </el-option>
        </el-select>
      </template>
      <!-- 查看详情表单 自定义 -->
      <template slot="fireassetDetailView" slot-scope="scope">
        <div
          class="slot-form"
          v-if="
            (scope.row.fireassetType == 1 || scope.row.fireassetType == 2) &&
            scope.row.annihilatorList &&
            scope.row.annihilatorList.length
          "
        >
          <label class="item-label">灭火器：</label>
          <table class="info-table">
            <tr>
              <th class="table-index">序号</th>
              <th style="width: 200px">名称</th>
              <th style="width: 200px">型号</th>
              <th style="width: 80px">数量</th>
              <th style="width: 150px">生产日期</th>
              <th style="width: 150px">检修日期</th>
            </tr>
            <tr v-for="(item, index) in scope.row.annihilatorList" :key="index">
              <td class="table-index" v-if="scope.row.annihilatorList">
                {{ index + 1 }}
              </td>
              <td>
                {{ scope.row.annihilatorList[index].name }}
              </td>
              <td>
                {{ returnAnnihilator(scope.row.annihilatorList[index].fireassetVersion) }}
              </td>

              <td class="table-index">
                {{ scope.row.annihilatorList[index].number }}
              </td>
              <td class="table-col">
                {{ scope.row.annihilatorList[index].produceTime }}
              </td>
              <td class="table-col">
                {{ scope.row.annihilatorList[index].fixTime }}
              </td>
            </tr>
          </table>
        </div>
        <div
          class="slot-form"
          v-if="
            scope.row.fireassetType == 2 &&
            scope.row.hydrantList &&
            scope.row.hydrantList.length
          "
        >
          <label class="item-label">消火栓：</label>
          <table class="info-table">
            <tr>
              <th class="table-index">序号</th>
              <th class="table-col" style="width: 200px">名称</th>
              <th class="table-index" style="width: 80px">数量</th>
            </tr>
            <tr v-for="(item, index) in scope.row.hydrantList" :key="index">
              <td class="table-index" v-if="hydrantList">
                {{ index + 1 }}
              </td>
              <td class="table-col">
                {{ scope.row.hydrantList[index].name }}
              </td>
              <td class="table-index">
                {{ scope.row.hydrantList[index].number }}
              </td>
            </tr>
          </table>
        </div>
      </template>
      <template slot="personnelPartView" slot-scope="scope">
        {{ returnDepartNames(scope.row) }}
      </template>
      <template slot="planCodeView" slot-scope="scope">
        {{ hasReturnLabel(scope.row.planCode, planList, "planCode", "planName") }}
      </template>
      <template slot="patrolItemGroupCodeView" slot-scope="scope">
        {{
          hasReturnLabel(
            scope.row.patrolItemGroupCode,
            groupList,
            "patrolItemGroupCode",
            "patrolItemGroupName"
          )
        }}
      </template>
      <template slot="viewFormSet" slot-scope="scope">
        <div class="qrCode" style="display: flex; align-items: center">
          <label style="width: 100px">设备二维码</label>
          <div class="code-content">
            <span>{{ scope.row.fireassetName }}</span>
            <vue-qr
              :text="h5Url + '?id=' + scope.row.fireassetCode"
              :logoSrc="downloadData.icon"
              :size="70"
              :margin="5"
            ></vue-qr>
          </div>
        </div>
      </template>
    </ioc-table>
    <!-- 二维码放大 -->
    <el-dialog title="设备二维码" :visible.sync="showQrCode" width="480px">
      <!-- <div style="display: flex;flex-direction: column;align-items: center;height: 100%;justify-content: center"
           id="print">
        <div class="qr_big">
          <vue-qr :text="downloadData.url"
                  :logoSrc="downloadData.icon"
                  :size="200"
                  id="printTest"
                  :margin="5"></vue-qr>
        </div>
        <div class="qr_big">
          <span>{{ rowInfo.fireassetName }}</span>
        </div>
      </div> -->
      <div style="display: flex; flex-direction: column" id="print">
        <div
          v-if="false"
          style="
            margin-bottom: 10px;
            display: flex;
            flex-direction: row;
            align-items: center;
          "
        >
          <img
            style="width: 110px; height: 40px; margin-right: 10px"
            src="../../../common/assets/images/logoOig.png"
          />
          <p style="font-size: 20px; letter-spacing: 9px; flex: 1">优合智慧园区</p>
        </div>
        <div
          class="content-bottom"
          style="
            display: flex;
            margin-top: 10px;
            flex-direction: row;
            justify-content: space-between;
          "
        >
          <div
            class="left-info"
            style="display: flex; flex-direction: column; justify-content: space-around"
          >
            <h2 style="margin-bottom: 15px; line-height: 28px">优合智慧园区</h2>
            <p style="margin-bottom: 15px; line-height: 28px">
              巡检点编号：{{ rowInfo.fireassetCode }}
            </p>
            <p style="margin-bottom: 15px; line-height: 28px">
              巡检点名称：{{ rowInfo.fireassetName }}
            </p>
            <p style="margin-bottom: 15px; line-height: 28px">
              所属楼栋/楼层：{{ rowInfo.buildingName }} /
              {{ rowInfo.floorName }}
            </p>
          </div>
          <!-- :logoSrc="downloadData.icon" -->
          <div class="qr_big">
            <vue-qr
              :logoSrc="downloadData.icon"
              :text="downloadData.url"
              :size="200"
              id="printTest"
              :margin="6"
            ></vue-qr>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="printTest">打印</el-button>
        <el-button @click="showQrCode = false">{{
          $t("taskCenter.button.cancel")
        }}</el-button>
      </span>
    </el-dialog>
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
    <!-- 人员选择弹框 -->
    <el-dialog
      title="人员选择"
      :visible.sync="linkDialog"
      width="760px"
      class="choose-container"
    >
      <div style="height: 500px">
        <ioc-table
          ref="personTable"
          :data="personData"
          :option="personOption"
          :page="personPage"
          @selection-change="personSelectionChange"
          @size-change="personChangeSize"
          @current-change="currentChange"
          @search-change="searchList"
          @search-reset="personReset"
        >
          <template slot="status" slot-scope="scope">
            <span v-if="scope.row.status === 1" style="color: #00e8bb">{{
              statusFormatter(scope.row)
            }}</span>
            <span v-if="scope.row.status === 2">{{ statusFormatter(scope.row) }}</span>
            <span v-if="scope.row.status === 4" style="color: yellow">{{
              statusFormatter(scope.row)
            }}</span>
          </template>
        </ioc-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmChoose">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../api";
import tableOption from "../const/manageOption";
import personOption from "../const/personOptions";
import utils from "@src/common/utils";
import { Dic } from "$utils";
import vueQr from "vue-qr";
import { Dates } from "$utils";

export default {
  components: {
    vueQr,
  },
  data() {
    return {
      exportDisabled: false,
      annihilatorList: [], //灭火器
      hydrantList: [], //消火栓
      fireassetType: Dic.find("SENU105"), //巡检类型
      fireassetVersion: Dic.find("SENU108"), //灭火器
      typeValue: "",
      value1: "",
      fireDisplay: false,
      fireplugDisplay: false,
      annihilatorModel: {
        annihilatorRule: {
          number: [{ required: true, message: "数量不能为空", trigger: "blur" }],
        },
        annihilatorList: [],
      },
      hydrantModel: {
        hydrantRule: {
          number: [{ required: true, message: "数量不能为空", trigger: "blur" }],
        },
        hydrantList: [],
      },
      personCheckList: [],
      personSearch: {},
      personPage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      personOption: personOption(),
      personData: [],
      linkDialog: false,
      downloadData: {
        // url: "http://10.40.146.150:8081/#/pages/workorder/handle-add?templateCode=20210617000495"//需要转化成二维码的网址
        url: "", //需要转化成二维码的网址
        icon: require("../../../../src/common/assets/images/wx.png"), //二维码中间的图片,可以不设置
      },
      h5Url: "https://universal.u-cold.com:18443/assetsManage", // utils.Cache.get("SYS_H5"),//小程序链接地址
      planList: [],
      groupList: [],
      floorList: [],
      buildingList: [],
      viewerInstance: null,
      viewerPhotos: [],
      assets: {},
      tableData: [],
      checkedAssets: [],
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      searchParams: {},
      option: tableOption(this),
      accountGroupsChecked: [],
      showQrCode: false,
      rowInfo: {},
      form: {
        fileCode: "",
        areaName: "",
        area: "",
        longitude: null,
        latitude: null,
        status: null,
      },
      statusOption: [
        {
          label: "库存中",
          value: 0,
        },
        {
          label: "使用中",
          value: 1,
        },
      ],
    };
  },
  computed: {
    currentTheme() {
      return this.$store.getters.currentTheme;
    },
  },
  mounted() {
    this.getList();
    this.getPeopleList();
  },
  created() {
    this.getBuildingList();
    this.getPlanList();
    this.getGroupList();
  },
  methods: {
    //灭火器型号
    returnAnnihilator(value) {
      if (!value || value == 0) {
        return "";
      }
      return this.fireassetVersion.filter((item) => {
        return item.value == value;
      })[0].label;
    },
    typeSelect(row) {
      this.typeValue = row.fireassetType;
    },
    //增加资产信息
    addFireasset(row, type) {
      if (type == 1) {
        this.annihilatorModel.annihilatorList.push({
          fireassetVersion: "",
          number: "",
          order: "",
          name: "",
          produceTime: "",
          fixTime: "",
        });
        this.fireDisplay = true;
      } else {
        this.hydrantModel.hydrantList.push({
          name: "",
          number: "",
          order: "",
        });
        this.fireplugDisplay = true;
      }
    },
    removeFireasset(index, type) {
      console.log(index, "====row1111");
      if (type == 1) {
        this.annihilatorModel.annihilatorList.splice(index, 1);
      } else {
        this.hydrantModel.hydrantList.splice(index, 1);
      }
    },
    personSelectionChange(row) {
      this.assets.departmentName = row
        .map((el) => {
          return el.departmentName;
        })
        .join(",");
      this.personCheckList = row;
    },
    // 人员选择确认弹框
    confirmChoose() {
      let personInfo = [];
      let name = [];
      this.personCheckList.forEach((item) => {
        personInfo.push({
          personnelCode: item.personnelCode,
          departmentCode: item.departmentCode,
        });
        name.push(item.name);
      });
      this.$set(this.$refs.crud.form, "personnelNames", name.join(","));
      this.$set(this.$refs.crud.form, "personnelInfoList", personInfo);
      this.linkDialog = false;
      this.$refs.crud.$refs["form"].validateField("personnelNames");
    },
    statusFormatter(data) {
      switch (data.status * 1) {
        case 1:
          return "在职";
        case 2:
          return "离职";
        case 4:
          return "未知";
        default:
          return data.status;
      }
    },
    // 员工弹框修改每页数据数量
    personChangeSize(val) {
      this.personPage.pageNum = 1;
      this.personPage.pageSize = val;
      this.getPeopleList();
    },
    currentChange(val) {
      this.personPage.pageNum = val;
      this.getPeopleList();
    },
    searchList(param) {
      this.personSearch = Object.assign(param);
      this.personPage.pageNum = 1;
      this.getPeopleList();
    },
    personReset() {
      this.getPeopleList();
    },
    openChoose(row) {
      this.linkDialog = true;
      this.personCheckList = [];
      this.$nextTick(() => {
        this.$refs.personTable.$refs.multipleTable.clearSelection();
        if (row.personnelInfoList && row.personnelInfoList.length > 0) {
          row.personnelInfoList.forEach((item) => {
            this.personData.forEach((pItem) => {
              if (item.personnelCode === pItem.personnelCode) {
                //  this.assets.departmentName=pItem.departmentName
                //  console.log(this.assets.departmentName)
                this.$refs.personTable.$refs.multipleTable.toggleRowSelection(pItem);
              }
            });
          });
        }
      });
    },
    batchImport(file) {
      if (
        file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length) !==
          "xlsx" &&
        file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length) !== "xls"
      ) {
        this.$message({
          message: "文件格式不正确",
          type: "warning",
        });
      } else {
        let formData = new FormData();
        formData.append("file", file.raw);
        // 调用导入接口
        this.$fetch(api.assetsManage.importFireAssetDevice, formData).then((response) => {
          if (response.success) {
            this.$message({
              message: "导入文件成功",
              type: "success",
            });
            this.getList();
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
            });
          }
          this.$refs.upload.clearFiles();
        });
      }
    },
    //导出
    exportDocument() {
      const params = {
        buildingCode: this.searchParams.buildingCode,
        fireassetName: this.searchParams.fireassetName,
        fireassetCode: this.searchParams.fireassetCode,
        fireassetType: this.searchParams.fireassetType,
      };
      // 兼容IE
      this.$fetchDownLoad(api.assetsManage.exportFireAssetDevice, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        if (response.data || response.success) {
          const content = response.data;
          const blob = new Blob([content], {
            type: "application/vnd.ms-excel",
          });
          const fileName =
            "巡检设备信息" + Dates.format(Date.now(), "yyyyMMddHHmmssms") + ".xlsx";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else {
          this.$message.error("导出请求失败，请稍后重试");
        }
      });
    },

    exportPic() {
      const params = {
        buildingCode: this.searchParams.buildingCode,
        fireassetName: this.searchParams.fireassetName,
        fireassetCode: this.searchParams.fireassetCode,
        fireassetType: this.searchParams.fireassetType,
      };
      this.exportDisabled = true;
      // 兼容IE
      this.$fetchDownLoad(api.assetsManage.exportFireAssetDeviceQrcode, params, {
        responseType: "arraybuffer",
      }).then((response) => {
        if (response.data || response.success) {
          const content = response.data;
          const blob = new Blob([content], { type: "application/pdf" });
          const fileName =
            "巡检点二维码信息" + Dates.format(Date.now(), "yyyyMMddHHmmssms") + ".pdf";
          if ("download" in document.createElement("a")) {
            // 非IE下载
            const elink = document.createElement("a");
            elink.download = fileName;
            elink.style.display = "none";
            elink.href = URL.createObjectURL(blob);
            document.body.appendChild(elink);
            elink.click();
            URL.revokeObjectURL(elink.href); // 释放URL 对象
            document.body.removeChild(elink);
          } else {
            // IE10+下载
            navigator.msSaveBlob(blob, fileName);
          }
        } else {
          this.$message.error("导出请求失败，请稍后重试");
        }
        this.exportDisabled = false;
      });
    },
    hasReturnLabel(val, list, key, lab) {
      let label = "";
      list.forEach((item) => {
        if (item[key] === val) {
          label = item[lab];
        }
      });
      return label;
    },
    getPeopleList() {
      const params = {};
      params.personnelType = 1;
      params.workNo = this.personSearch.workNo;
      params.name = this.personSearch.name;
      params.pageNum = this.personPage.pageNum;
      params.pageSize = this.personPage.pageSize;
      params.status = 1;
      this.$fetch(api.assetsManage.queryPersonnel, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.personData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.personPage.total = response.returnObj ? response.returnObj.total : 0;
      });
    },
    getPlanList() {
      const param = {
        planCycle: "",
        planName: "",
      };
      this.$fetch(api.assetsManage.queryPatrolPlanList, param).then((res) => {
        if (res.success) {
          this.planList = res.returnObj;
        }
      });
    },
    getGroupList() {
      const param = {
        patrolItemGroupName: "",
      };
      this.$fetch(api.assetsManage.queryPatrolItemGroupConfigList, param).then((res) => {
        if (res.success) {
          this.groupList = res.returnObj;
        }
      });
    },
    getBuildingList() {
      const param = {
        pageFlag: false,
        buildingType: 1, //1楼栋2楼层
      };
      this.$fetch(api.assetsManage.queryBuildingList, param).then((res) => {
        if (res.success) {
          this.buildingList = res.returnObj;
        }
      });
    },
    handleFloorChange(val, row) {
      this.floorList.forEach((item) => {
        if (item.buildingCode === val) {
          row.floorName = item.buildingName;
        }
        ``;
      });
    },
    handleBuildingChange(val, row) {
      this.buildingList.forEach((item) => {
        if (item.buildingCode === val) {
          row.buildingName = item.buildingName;
        }
      });
      // row.floorCode = '';
      const param = {
        buildingCode: val,
        pageFlag: false,
        buildingType: 2, //1楼栋2楼层
      };
      this.$fetch(api.assetsManage.queryBuildingList, param).then((res) => {
        if (res.success) {
          this.floorList = res.returnObj;
        }
      });
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    showViewer(img, e) {
      this.viewerPhotos = [
        e.target.src.indexOf("default/default.png") == -1
          ? e.target.src + "&sourceFileFlag=1"
          : e.target.src,
      ];
      this.viewerInstance.show();
    },
    handleSearchReset() {
      this.searchParams.fireassetName = "";
      this.searchParams.fireassetType = "";
      this.searchParams.buildingCode = "";
      this.page = {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      };
      this.getList();
    },
    getList() {
      const params = {
        buildingCode: this.searchParams.buildingCode,
        fireassetName: this.searchParams.fireassetName,
        fireassetCode: this.searchParams.fireassetCode,
        fireassetType: this.searchParams.fireassetType,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      };
      const loading = this.$loading({
        lock: true,
        text: "请求中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$fetch(api.assetsManage.queryFireAssetDeviceByPage, params).then(
        (response) => {
          setTimeout(() => {
            loading.close();
          }, 500);

          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          }
          this.tableData = response.returnObj
            ? Object.freeze([...response.returnObj.list])
            : [];
          this.page.total = response.returnObj ? response.returnObj.total : 0;
          this.$refs.crud.selectClear();
        }
      );
    },
    handleCurrentChange(val) {
      this.page.currentPage = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      this.getList();
    },
    handleSearchChange(param) {
      this.searchParams = param;
      this.page.currentPage = 1;
      this.getList();
    },
    handleAddAssets() {
      //模拟，后台数据给出暴露
      this.annihilatorModel.annihilatorList = [];
      this.hydrantModel.hydrantList = [];
      this.fireplugDisplay = false;
      this.fireDisplay = true;
      this.typeValue = "";
      this.getPlanList();
      this.getGroupList();
      this.$refs.crud.rowAdd();
    },
    handleView(row, index) {
      this.$refs.crud.rowView(row, index);
    },
    handleEdit(row, index) {
      this.typeValue = row.fireassetType;
      this.fireDisplay = true;
      if (this.typeValue == 1) {
        //
      } else {
        this.fireplugDisplay = true;
      }
      this.getPlanList();
      this.getGroupList();
      this.annihilatorModel.annihilatorList = row.annihilatorList;
      this.annihilatorModel.annihilatorList.forEach((item) => {
        item.fireassetVersion = Number(item.fireassetVersion);
      });
      this.hydrantModel.hydrantList = row.hydrantList;
      row.fireassetType = Number(row.fireassetType);
      // row.fireassetVersion = Number(row.fireassetVersion);
      this.rowInfo = row;
      const param = {
        buildingCode: row.buildingCode,
        pageFlag: false,
        buildingType: 2, //1楼栋2楼层
      };
      this.$fetch(api.assetsManage.queryBuildingList, param).then((res) => {
        if (res.success) {
          this.floorList = res.returnObj;
        }
      });
      this.$nextTick(() => {
        this.$refs.crud.rowEdit(row, index);
      });
    },
    handleDel(row) {
      const params = {
        fireassetCodeList: [row.fireassetCode],
      };
      this.$confirm("您确定删除该消防资源吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.assetsManage.deleteFireAssetDeviceInfo, params).then(
          (response) => {
            if (response && response.success) {
              this.$message.success(response.msgContent);
              this.getList();
            } else {
              this.$message.error(response.msgContent);
            }
          }
        );
      });
    },
    handelDelAssets() {
      if (this.checkedAssets.length === 0) {
        this.$message({
          type: "warning",
          duration: 2000,
          message: "请选择你要删除的资产",
        });
        return;
      }
      this.$confirm("您确定删除这些资产吗?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.assetsManage.deleteFireAssetDeviceInfo, {
          fireassetCodeList: this.checkedAssets,
        }).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
          } else {
            this.$message.success(response.msgContent);
            this.getList();
          }
        });
      });
    },
    // 新增消防资产
    handleCreate(addInfo, done) {
      // this.fireDisplay=false
      // this.fireplugDisplay=false
      addInfo.fireassetType = Number(addInfo.fireassetType);
      addInfo.annihilatorList = this.annihilatorModel.annihilatorList.map((el, index) => {
        return {
          fireassetType: 1,
          fireassetVersion: el.fireassetVersion,
          fixTime: el.fixTime,
          name: el.name,
          number: el.number,
          produceTime: el.produceTime,
        };
      });
      addInfo.hydrantList = this.hydrantModel.hydrantList.map((el, index) => {
        return {
          fireassetType: 2,
          name: el.name,
          number: el.number,
        };
      });
      if (!this.$refs.annihilatorForm) {
        this.$message.warning("请填写资产信息");
        return false;
      }
      this.$refs.annihilatorForm.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.$fetch(api.assetsManage.addFireAssetDeviceInfo, addInfo).then((res) => {
            if (res.success) {
              this.$message.success("新增成功！");
              this.handleSearchReset();
              done();
            } else {
              this.$message.error(res.msgContent);
            }
          });
        }
      });
    },
    // 修改消防资产
    handleUpdate(updateInfo, done) {
      const param = {
        buildingCode: updateInfo.buildingCode,
        departmentCode: updateInfo.personnelInfoList
          .map((el) => {
            return el.departmentCode;
          })
          .join(","),
        fireassetId: updateInfo.fireassetId,
        fireassetDesc: updateInfo.fireassetDesc,
        fireassetCode: updateInfo.fireassetCode,
        fireassetName: updateInfo.fireassetName,
        fireassetType: updateInfo.fireassetType,
        floorCode: updateInfo.floorCode,
        patrolItemGroupCode: updateInfo.patrolItemGroupCode,
        personnelCode: updateInfo.personnelInfoList
          .map((el) => {
            return el.personnelCode;
          })
          .join(","),
        planCode: updateInfo.planCode,
        annihilatorList: this.annihilatorModel.annihilatorList.map((el, index) => {
          return {
            fireassetType: 1,
            name: el.name,
            fireassetVersion: el.fireassetVersion,
            fixTime: el.fixTime,
            number: el.number,
            produceTime: el.produceTime,
          };
        }),
        hydrantList: this.hydrantModel.hydrantList.map((el, index) => {
          return {
            fireassetType: 2,
            name: el.name,
            number: el.number,
          };
        }),
        // fireassetVersion: updateInfo.fireassetVersion,
        personnelInfoList: updateInfo.personnelInfoList,
      };
      this.$refs.annihilatorForm.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.$fetch(api.assetsManage.updateFireAssetDeviceInfo, param).then((res) => {
            if (res.success) {
              this.$message.success("修改成功！");
              this.handleSearchReset();
              done();
            } else {
              this.$message.error(res.msgContent);
            }
          });
        }
      });
    },
    closeDialog() {
      this.annihilatorModel.annihilatorList = [];
      this.hydrantModel.hydrantList = [];
      this.fireplugDisplay = false;
      this.fireDisplay = false;
    },
    handleSelectionChange(items) {
      this.checkedAssets = items.map((item) => item.fireassetCode);
    },
    showCode(rowInfo) {
      this.showQrCode = true;
      this.rowInfo = rowInfo;
      this.downloadData.url = this.h5Url + "?id=" + rowInfo.fireassetCode;
      console.log(this.downloadData);
    },
    printTest() {
      let newWin = window.open("");
      const docStr = document.getElementById("print").outerHTML; //要打印的div的内容
      // newWin.document.body.innerHTML = `<span>${name}</span><img src='${qrSrc}' />`;
      newWin.document.write(docStr);
      newWin.document.close(); //在IE浏览器中使用必须添加这一句
      newWin.focus(); //在IE浏览器中使用必须添加这一句
      setTimeout(() => {
        newWin.print(); //打印
        newWin.close(); //关闭窗口
      }, 100);
    },
  },
};
</script>
<style lang="scss">
@import "../style/manage.scss";
.el-date-editor {
  font: 8px;
  width: 140px !important;
}

.export-tips {
  margin-left: 5px;
  color: red;
  vertical-align: middle;
}

.assets-wrap {
  .add-row {
    table {
      border-collapse: collapse;
    }
    i {
      line-height: 30px;
      height: 30px;
    }
  }
}
.code-content {
  display: flex;
  width: 100px;
  padding-bottom: 5px;
  flex-direction: column;
}
.slot-form {
  table {
    border-collapse: collapse;
  }
  .info-table td,
  th {
    border: 1px solid;
    text-align: center;
    @include set_theme_color(border-color, top-menu-border-color);
  }
  //display: flex;
  font: 8px !important;
  // flex-direction: row;
  // justify-content: flex-start;

  .el-input__inner {
    height: 32px;
    width: 100%;
    text-align: center;
    line-height: 32px;
  }
  .table-index {
    width: 50px;
  }
}
</style>
